(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hoyo-slide"] && !Shopify.designMode) return;
  try {
    
  class HoyoSlideshow extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-hoyo-track]');
      this.slides = this.track ? Array.from(this.track.children) : [];
      if (!this.track || this.slides.length === 0) return;

      this.dotsContainer = this.querySelector('[data-hoyo-dots]');
      this.prevButton = this.querySelector('[data-hoyo-prev]');
      this.nextButton = this.querySelector('[data-hoyo-next]');
      this.speed = (parseFloat(this.dataset.speed) || 6) * 1000;
      this.autoplay = this.dataset.autoplay === 'true' && this.slides.length > 1;
      this.loop = this.dataset.loop !== 'false';
      this.index = Math.max(0, this.slides.findIndex((slide) => slide.dataset.active === 'true'));

      this.buildDots();
      this.bind();
      this.render();
      this.startAutoplay();
    }

    buildDots() {
      if (!this.dotsContainer) return;
      this.dotsContainer.innerHTML = '';
      this.slides.forEach((slide, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'hoyo-slideshow__dot';
        dot.setAttribute('aria-label', String(index + 1));
        dot.addEventListener('click', () => this.goTo(index));
        this.dotsContainer.appendChild(dot);
      });
      this.dots = Array.from(this.dotsContainer.children);
    }

    bind() {
      if (this.prevButton) this.prevButton.addEventListener('click', () => this.step(-1));
      if (this.nextButton) this.nextButton.addEventListener('click', () => this.step(1));

      // 滑动 / 拖拽切换(触屏与鼠标都有效)
      let startX = 0;
      let startY = 0;
      let pointerDown = false;

      this.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        // 点在交互元素上就交给它们处理,不要进入拖拽(否则指针捕获会吞掉 click)
        if (event.target.closest('button, a, input, select, textarea, [role="button"]')) return;
        pointerDown = true;
        // 指针捕获:鼠标移出元素后 pointerup 仍会回到这里(桌面拖拽必需)
        if (this.setPointerCapture) {
          try {
            this.setPointerCapture(event.pointerId);
          } catch (error) {
            /* 某些浏览器在无活动指针时会抛错,忽略即可 */
          }
        }
        startX = event.clientX;
        startY = event.clientY;
        this.stopAutoplay();
      });

      this.addEventListener('pointerup', (event) => {
        if (!pointerDown) return;
        pointerDown = false;
        const dx = event.clientX - startX;
        const dy = event.clientY - startY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          this.step(dx < 0 ? 1 : -1);
        }
        this.startAutoplay();
      });

      this.addEventListener('dragstart', (event) => event.preventDefault());

      this.addEventListener('pointercancel', () => {
        pointerDown = false;
        this.startAutoplay();
      });

      this.addEventListener('keydown', (event) => {        if (event.key === 'ArrowLeft') this.step(-1);
        if (event.key === 'ArrowRight') this.step(1);
      });

      ['pointerenter', 'focusin', 'touchstart'].forEach((event) =>
        this.addEventListener(event, () => this.stopAutoplay(), { passive: true })
      );
      ['pointerleave', 'focusout'].forEach((event) =>
        this.addEventListener(event, () => this.startAutoplay())
      );
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.stopAutoplay();
        else this.startAutoplay();
      });
    }

    goTo(index) {
      const count = this.slides.length;
      if (count === 0) return;
      this.index = this.loop
        ? ((index % count) + count) % count
        : Math.max(0, Math.min(index, count - 1));
      this.render();
      this.restartAutoplay();
    }

    step(direction) {
      this.goTo(this.index + direction);
    }

    render() {
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.dataset.active = String(active);
        slide.setAttribute('aria-hidden', String(!active));
      });

      if (this.dots) {
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
      }

      const single = this.slides.length <= 1;
      if (this.prevButton) this.prevButton.hidden = single || (!this.loop && this.index === 0);
      if (this.nextButton) {
        this.nextButton.hidden = single || (!this.loop && this.index === this.slides.length - 1);
      }
    }

    startAutoplay() {
      if (!this.autoplay || this.timer) return;
      this.timer = setInterval(() => this.goTo(this.index + 1), this.speed);
    }

    stopAutoplay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    restartAutoplay() {
      if (!this.autoplay) return;
      this.stopAutoplay();
      this.startAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }
  }

  if (!customElements.get('hoyo-slideshow')) {
    customElements.define('hoyo-slideshow', HoyoSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
